
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors/deals/[id]/messages",
      function () {
        return require("private-next-pages/vendors/deals/[id]/messages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors/deals/[id]/messages"])
      });
    }
  